export const projectTypeList = [
    { lable: "Business Name Registration", value: "Business Name Registration" },
    { lable: "Partnership Registration", value: "Partnership Registration" },
    { lable: "Company Registration", value: "Company Registration" },
    { lable: "AGPO Registration", value: "AGPO Registration" },
    { lable: "NHIF Registration", value: "NHIF Registration" },
    { lable: "NSSF Registration", value: "NSSF Registration" },
    { lable: "NHIF Compliance Certificate", value: "NHIF Compliance Certificate" },
    { lable: "NSSF Compliance Certificate", value: "NSSF Compliance Certificate" },
    { lable: "Individual KRA Pin Registration", value: "Individual KRA Pin Registration" },
    { lable: "Company KRA Pin Registration", value: "Company KRA Pin Registration" },
    { lable: "Individual Tax Compliance Certificate", value: "Individual Tax Compliance Certificate" },
    { lable: "Company Tax Compliance Certificate", value: "Company Tax Compliance Certificate" },
    { lable: "Nil Tax Filing", value: "Nil Tax Filing" },
    { lable: "Employment Income Tax Filing", value: "Employment Income Tax Filing" },
    { lable: "Witholding Tax Filing", value: "Witholding Tax Filing" },
    { lable: "Business Name & Partnerships Tax Filing", value: "Business Name & Partnerships Tax Filing" },
    { lable: "Company Tax Filing", value: "Company Tax Filing" },
    { lable: "Companies R>2M Tax Filing", value: "Companies R>2M Tax Filing" },
    { lable: "Foreigners Tax Registration", value: "Foreigners Tax Registration" },
    { lable: "PAYE Tax Filing", value: "PAYE Tax Filing" },
    { lable: "VAT Tax Filing", value: "VAT Tax Filing" },
    { lable: "WHT Tax Filing", value: "WHT Tax Filing" },
    { lable: "General Consultation", value: "General Consultation" },
    { lable: "Business Plan", value: "Business Plan" },
    { lable: "Financial Modeling", value: "Financial Modeling" },
    { lable: "ETIMS", value: "ETIMS" },
    { lable: "Non-Resident KRA Pin Application", value: "Non-Resident KRA Pin Application" },
    { lable: "Tax Agent Documentation", value: "Tax Agent Documentation" },
    { lable: "Book Keeping", value: "Book Keeping" },
    { lable: "AIA CRM", value: "AIA CRM" },
    { lable: "Insurance", value: "Insurance" },
    { lable: "Taxation Package Training", value: "Taxation Package Training" },
    { lable: "MS Advanced Excel", value: "MS Advanced Excel" },
    { lable: "Quickbooks", value: "Quickbooks" },
    { lable: "PAYE", value: "PAYE" },
    { lable: "WHT", value: "WHT" },
    { lable: "VAT", value: "VAT" },
    { lable: "Rental Income", value: "Rental Income" },
    { lable: "NSSF Compliance Letter", value: "NSSF Compliance Letter" },
    { lable: "NHIF Compliance Letter", value: "NHIF Compliance Letter" },
    { lable: "Individual Letter For VAT Obligation Removal", value: "Individual Letter For VAT Obligation Removal" },
    { lable: "Company Letter For VAT Obligation Removal", value: "Company Letter For VAT Obligation Removal" },
    { lable: "Company Waiver Application Letter", value: "Company Waiver Application Letter" },
    { lable: "Individual Waiver Application Letter", value: "Individual Waiver Application Letter" },
    { lable: "Landlord Tenants Invoicing", value: "Landlord Tenants Invoicing" },
    { lable: "Tenancy Agreement", value: "Tenancy Agreement" },
    { lable: "PDF Guide on Filing WHT", value: "PDF Guide on Filing WHT" },
    { lable: "KRA P9 Template", value: "KRA P9 Template" },
    { lable: "Excel Payroll - 20", value: "Excel Payroll - 20" },
    { lable: "Excel Payroll - 100", value: "Excel Payroll - 100" },
    { lable: "Excel Payroll - 120", value: "Excel Payroll - 120" },
    { lable: "Excel Payroll - 200", value: "Excel Payroll - 200" },
    { lable: "Excel Payroll - Passport Photo", value: "Excel Payroll - Passport Photo" },
    { lable: "CCK", value: "CCK" },
    { lable: "Tendering", value: "Tendering" },
    { lable: "NCA License", value: "NCA License" },
    { lable: "MRI", value: "MRI" },
    { lable: "Business Permit", value: "Business Permit" },
    { lable: "Payroll Services", value: "Payroll Services" },

]